import { Docket, DocketItem, DocketType, Order, OrderItem, OrderItemStatus } from "./Order";

export enum OMSDocketGeneratedFrom {
  Docket = 1,
  Order = 2,
}

export type OMSDisplayDocket = {
  docketGeneratedFrom: OMSDocketGeneratedFrom;
  type: DocketType;
  noteOnlyStatus?: OrderItemStatus;
} & (DocketFromDocket | DocketFromOrder);

export type DocketFromOrder = {
  docketGeneratedFrom: OMSDocketGeneratedFrom.Order;
  printerAreaIds: string[];
  paid: boolean;
  docketItems: DocketFromOrderDocketItems[];
  tableNo: string;
  time?: string;
  hidden?: {
    one: boolean;
    prep: boolean;
    serve: boolean;
  };
} & Order;

export type DocketFromDocket = {
  docketGeneratedFrom: OMSDocketGeneratedFrom.Docket;
  docketGenerationTime: number;
  docketId: string;
  docketItems: DocketFromDocketDocketItems[];
} & Omit<Docket, "docketItems">;

export type DocketItemTransfer = { tableNo: string; quantity: number };
export type DocketFromDocketDocketItems = { docketId: string; docketItemId: string; isFromFirstDocket?: boolean; docketItemGenerationTime?: number; transferredTo?: DocketItemTransfer[] } & DocketItem;
export type DocketFromOrderDocketItems = { heading: string; customerNames?: string[] } & OrderItem;

export enum UpdateDocketType {
  Complete,
  Reset,
}

export enum DisplayType {
  PrepDisplay = 0,
  ServeDisplay = 1,
}

export enum ProgressType {
  Active = 0,
  Completed = 1,
  All = 2,
}

export enum OrderModeType {
  MenuPlan = 0,
  SentOrder = 1,
  BasketOrder = 2,
}

export enum OrderDisplayMode {
  Docket = 1,
  Table = 2,
}

export enum OperationMode {
  AllStep,
  OneStep,
}

export interface ColourAlertTimeRange {
  min: number;
  max?: number; // optional, undefined means no upper bound
}
export interface ColourAlert {
  _key: string;
  colour: string;
  timeRange: ColourAlertTimeRange;
  order: number;
}

export interface ColourAlertsForOrderTime {
  enabled: boolean;
  alerts: { [id: string]: ColourAlert };
}
